import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { vn_app_zone_notification } from '../../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { header } from '../header';
import { adminTransmissionGroupEdit_template } from '../../components/templates/recruiting/adminTransmissionGroupEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_transmission_group_edit extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_transmission_group_edit';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Transmission Group');
        this.tpl = new adminTransmissionGroupEdit_template('adminTransmissionGroupEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        const id = this.getGroupId();
        if (!id) {
            this.tpl.setGroup({ id: 0, label: '', description: '', transmissions: [] });
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading transmission group...');
        const req = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/scheduling/group/' + id, [], this);
        req.onReadyStateFunction = this.onGroupReturn;
        req.execute();
    }
    /**
     * Handle the API response for group.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onGroupReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setGroup(JSON.parse(req.request.response || '{}'));
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Save group through the API.
     *
     * @return Promise<void>
     */
    async saveGroup() {
        const payload = this.tpl.getPayload();
        if (!payload.label) {
            alert('Group label is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving transmission group...');
        const response = await fetch('/api/admin/rest/api/lead/transmission/scheduling/group', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save transmission group.');
            return;
        }
        page('/admin/transmissionGroup/' + result.objectId);
    }
    /**
     * Handle run scheduled.
     *
     * @return Promise<void>
     */
    async runScheduled() {
        const payload = this.tpl.getPayload();
        const response = await fetch('/api/admin/rest/api/lead/transmission/run_scheduled/synchronous?interval=' + encodeURIComponent(payload.label || ''), {
            method: 'GET',
            credentials: 'same-origin',
        });
        const result = await response.json();
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to queue scheduled transmission task.');
            return;
        }
        this.validationTemplate.clearMessages();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, this.formatQueuedTaskMessage(result, 'Scheduled transmission task queued.'));
    }
    /**
     * Navigate to edit transmission.
     *
     * @param id number
     * @return void
     */
    editTransmission(id) {
        page('/admin/transmission/' + id);
    }
    /**
     * Navigate back to groups.
     *
     * @return void
     */
    backToGroups() {
        page('/admin/transmissionGroups');
    }
    /**
     * Return group id.
     *
     * @return number
     */
    getGroupId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
    /**
     * Build a success message that includes queued task details.
     *
     * @param result any
     * @param fallback string
     * @return string
     */
    formatQueuedTaskMessage(result, fallback) {
        const details = [];
        if (result.taskId) {
            details.push('Task #' + result.taskId);
        }
        if (result.operation) {
            details.push('operation ' + result.operation);
        }
        return details.length ? fallback + ' ' + details.join(', ') + '.' : (result.message || fallback);
    }
}
